import { render, staticRenderFns } from "./CultureAdd.vue?vue&type=template&id=3d6e4af9"
import script from "./CultureAdd.vue?vue&type=script&lang=js"
export * from "./CultureAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports